<app-header
  #header
  (validFromChange)="onValidFromChange($event)"
  (valueChange)="onFormValueChanged($event)"
  (formSubmit)="onFormSubmit($event)"
  (print)="showPrintConfigDialog($event)"
  [changedProducts]="(changedProducts$ | async) ?? []">
</app-header>

@if ((selected$ | async); as active) {
  <main class="mt-3 auto-overflow">
    <h1 class="text-2xl font-semibold">{{ '#KUNDEN_KONDITIONSLISTE.LIST.TITLE' | translate }}</h1>
    <table class="soft-table mt-3 table-products border border-solid border-gray-200" @slideFade>
      <thead class="h-10">
        <tr class="h-10 border-b border-solid border-gray-200 p-2 text-xs" style="height: 2rem">
          <th>&nbsp;{{ '#KUNDEN_KONDITIONSLISTE.LIST.ARTICLE' | translate }}</th>
          <th class="text-center">{{ '#KUNDEN_KONDITIONSLISTE.LIST.VALID_FROM' | translate }}</th>
          <th class="text-center">{{ '#KUNDEN_KONDITIONSLISTE.LIST.VALID_UNTIL' | translate }}</th>
          <th class="text-center">{{ '#KUNDEN_KONDITIONSLISTE.LIST.UNIT' | translate }}</th>
          <th class="text-right">{{ '#KUNDEN_KONDITIONSLISTE.LIST.CLIENT_SALE_PRICE' | translate }}</th>
          <th class="">{{ '#KUNDEN_KONDITIONSLISTE.LIST.CLIENT_SALE_NEW_PRICE' | translate }}</th>
          <th>{{ '#KUNDEN_KONDITIONSLISTE.LIST.NOTE_LINE' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (product of (products$ | async); track product; let last = $last) {
          <tr class="product-item"
            [ngClass]="{ 'border-b border-solid border-gray-200': !last }">
            <td style="min-width: 20rem; max-width: 20rem;">
              <div class="product-details">
                <i class="fa-regular fa-clock-rotate-left ml-1 mr-5 cursor-pointer text-gray-800 hover:text-primary-600 font-semibold"
                  (click)="toggleSelected(product)"
                  [ngClass]="{ 'text-primary-700': active?.id === product.id }">
                </i>
                <!-- <img class="product-image" [src]="'./assets/modules/kunden-konditionsliste/images/image-placeholder.jpg'" [alt]="product.product.number"> -->
                <div>
                  <div class="product-number">{{ product.product.number }}</div>
                  <div class="product-description">{{ product.product.description1 }}</div>
                </div>
              </div>
            </td>
            <td class="w-36 text-center">{{ product.valid_from | date:'dd.MM.yyyy' }}</td>
            <td class="w-36 text-center">{{ (product.valid_until | date:'dd.MM.yyyy') || '-' }}</td>
            <td class="text-center font-weight-bold">{{ product.unit.unit }}</td>
            <td class="text-right font-weight-bold">{{ product.price | currency:'EUR' }}</td>
            <td>
              <div class="flex flex-row">
                <soft-number-input
                  #num
                  placeholder="{{ '#KUNDEN_KONDITIONSLISTE.LIST.PRICE_PER_UNIT' | translate }}"
                  (change)="onRowInputChange(product, { price: num?.value() ?? undefined, note: note?.value() ?? undefined }, header.formGroup.value)">
                </soft-number-input>
                <span class="fa-regular fa-euro-sign mt-2 ml-2"></span>
              </div>
            </td>
            <td style="min-width: 12rem !important; max-width: 18rem !important;">
              <soft-input #note
                [value]="product?.note ?? null"
                placeholder="{{ '#KUNDEN_KONDITIONSLISTE.LIST.NOTE' | translate }}"
                (change)="onRowInputChange(product, { price: num?.value() ?? undefined, note: note?.value() ?? undefined }, header.formGroup.value)">
              </soft-input>
            </td>
          </tr>
          @if (active?.id === product.id) {
            @for (history of product.history; track history; let first = $first) {
              <tr
                class="product-item history bg-gray-50"
                [ngClass]="{ 'border-t border-solid border-gray-100': first }">
                <td style="min-width: 20rem; max-width: 20rem;">
                  <div class="product-details"></div>
                </td>
                <td class="w-36 text-center">{{ history.valid_from | date:'dd.MM.yyyy' }}</td>
                <td class="w-36 text-center">{{ (history.valid_until | date:'dd.MM.yyyy') || '-' }}</td>
                <td class="text-center font-weight-bold">{{ history.unit.unit }}</td>
                <td class="text-right font-weight-bold">{{ history.price | currency:'EUR' }}</td>
                <td></td>
                <td style="min-width: 12rem !important; max-width: 18rem !important;">
                  <span class="truncate">
                    {{ history?.note || '-' }}
                  </span>
                </td>
              </tr>
            }
          }
        }
      </tbody>
    </table>
    <!-- <pre>{{ changedProducts$ | async | json }}</pre> -->
  </main>
}
